import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { GoogleSheetsBaseService } from './google-sheets-base.service';

@Injectable({
  providedIn: 'root'
})
export class PersonSheetsService extends GoogleSheetsBaseService {
  
  /**
   * Gets a list of person suffix labels.
   * @returns An observable of the suffix labels.
   */
  getSuffixLabels(): Observable<any> {
    const tabName = 'person';
    const startCell = 'B2';
    const endCell = 'B50';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of person prefix labels.
   * @returns An observable of the prefix labels.
   */
  getPrefixLabels(): Observable<any> {
    const tabName = 'person';
    const startCell = 'A2';
    const endCell = 'A30';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of person title labels.
   * @returns An observable of the title labels.
   */
  getTitleLabels(): Observable<any> {
    const tabName = 'person';
    const startCell = 'C2';
    const endCell = 'C400';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of person function labels.
   * @returns An observable of the function labels.
   */
  getPersonFunctionLabels(): Observable<any> {
    const tabName = 'person';
    const startCell = 'D2';
    const endCell = 'D30';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }
}